<div class="quick-menu-root">
  <app-header>{{quickMenuLabel | transloco }}</app-header>
  <div class="grid">
    <app-quick-menu-item id="lnr-quick-menu-rewards" (click)="onRoute(RoutesKeys.REWARDS)"
    icon="{{ quickMenuItems.rewards[1] }}">{{ quickMenuItems.rewards[0] | transloco }}</app-quick-menu-item>
    <app-quick-menu-item id="lnr-quick-menu-coupons" (click)="onRoute(RoutesKeys.COUPONS)"
    icon="{{ quickMenuItems.coupons[1] }}">{{ quickMenuItems.coupons[0] | transloco }}</app-quick-menu-item>
    <app-quick-menu-item id="lnr-quick-menu-pointbalance" (click)="onRoute(RoutesKeys.POINT_BALANCE_LIST)"
    icon="{{ quickMenuItems.pointBalanceList[1] }}">{{ quickMenuItems.pointBalanceList[0] | transloco }}</app-quick-menu-item>
    <app-quick-menu-item id="lnr-quick-menu-businesssettings" (click)="onRoute(RoutesKeys.BUSINESS_SETTINGS)"
    icon="{{ quickMenuItems.businessSettings[1] }}">{{ quickMenuItems.businessSettings[0] | transloco }}</app-quick-menu-item>
  </div>
</div>
